import { render, staticRenderFns } from "./leaveRecord.vue?vue&type=template&id=2ee2e1f5&"
import script from "./leaveRecord.vue?vue&type=script&lang=js&"
export * from "./leaveRecord.vue?vue&type=script&lang=js&"
import style0 from "./leaveRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports